import React, { Component } from 'react';
import { TeamEditor } from './TeamEditor';
import $ from 'jquery';
import ls from 'local-storage';
import Swal from 'sweetalert2';
export default class TeamManager extends Component {
    static displayName = TeamManager.name;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            teams: [], accNum: "", container: null, edit: null, hasTeams:true, show: false, message:null,teamMessage: "Fetching Teams...",
            currentTeam:this.props.currentTeam,currentTeamName:""
        };
       
    }
    getData = async () => {
        console.log("Get Data");
        const resp = await fetch('api/team/teamlist', {
            method: 'GET',
            credentials: 'same-origin'
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();
            
                if (this._isMounted) {
                    await this.setState({ teams: jdata.teams, accNum: jdata.accNum });
                    var hasTeams = this.state.teams.length > 0;
                    if (!hasTeams) {
                        this.setState({ teamMessage: "You aren't part of a team yet. Click New to create one." , hasTeams:false});
                    }
                    else {
                        var currentTeamTestList = jdata.teams.filter(x => x.id === this.state.currentTeam);
                      
                        if (currentTeamTestList.length>0 ) {
                            var name = currentTeamTestList[0].name;
                            await this.setState({ currentTeamName: name });
                        }
                    }                  
         
                }

            } catch (e) {
                console.log(e);
                console.log(resp.statusText);    
                //console.log(this.state.currentTeam);
                //console.log(this.state.currentTeamName);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
           
        }
    }
       
    addTeam = async () => {
        $('#teamModal').modal('hide');
        await this.setState({ edit: "", show: true, container: null });
        await this.setState({
            show: true, container: (<div>
                {<TeamEditor show="true" team={null} accNum={this.state.accNum} saveSuccess={this.saveSuccess} refresh={() => this.getData()}/>}
            </div>)
        });
        // console.log(this.state.container);
    };
 
     editTeam  = async (e, team) =>{
  
        e.preventDefault();
        await this.setState({ edit: team, show: true ,container:null});
        await this.setState({
            container: (<div >
                {this.state.show ? <TeamEditor team={team} accNum={this.state.accNum} saveSuccess={this.saveSuccess} refresh={() => this.getData()} /> : ""}
            </div>)            
        });
        
    }

    leaveTeamConfirm = async (e, team) => {
        e.preventDefault();
        Swal.fire({
            title: 'Leave',
            text: 'Are you sure you want to leave team ' + team.name + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, leave.',
            cancelButtonText: 'No.'
        }).then(async (result) => {
            if (result.value) {
                await this.leaveTeamSubmit(team);
            } else if (result.dismiss === Swal.DismissReason.cancel) {

            }
        })
    }
    leaveTeamSubmit = async (team) => {
       
        var data = { teamid: team.id, account:this.state.accNum}

        const resp = await fetch('api/team/leaveteam', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (resp.status === 200) {
            try {
                const jdata = await resp.json();
                this.setState({ message: jdata.statusText });
            } catch (e) {
                console.log(resp.statusText);
                this.setState({ message: '500: Check console' })
            }
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
           
        }
        if (team.id === ls.get('currentTeam')) {
            ls.remove('currentTeam');
        }
        this.saveSuccess();
    }

    saveSuccess = (id, deleting=false) => {    
        console.log(id, deleting);
        if (deleting) {
            if (id === ls.get('currentTeam')) {
                ls.remove('currentTeam');
            }
            this.props.onTeamListChange();
        }
        if (id!==undefined) {
            console.log("Calling onTeamListChange");
            this.props.onTeamListChange(id);
        } else {
            this.setState({ message: <div className="alert alert-info" > Changes Saved </div> })
            this.props.onTeamListChange();
        }
     
        (async () => {
            this.getData()
        })()

     
    };
    
   
    componentDidMount() {
       
        this._isMounted = true;
        (async () => {
            this.getData()
        })();
      
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    //test = async () => {
    //    this.props.onTeamListChange("team#a0bbb743-d056-4728-b845-03074fb592f2");
    //}
  
    render() {
        
        const msg = this.state.message;
        const tmsg = this.state.teamMessage;
        const constContainer = this.state.container;
        const teamCallout = this.state.hasTeams ? (<h2>Your Current Team is {this.state.currentTeamName} </h2> ):
    (<h2>Create a Team to get started </h2>);
      
        return (
            <div>              
                <div className="row">
                    <div className="col">
                        <button className="pull-right btn btn-secondary"
                            onClick={this.addTeam}>
                            <i className="fa fa-plus"></i> New</button>

                        {teamCallout}

                        {msg} 
                        <div className="mt20">
                            
                            <div className="team-list"><table className="table table-striped table-bordered table-hover"><tbody>

                                {this.state.teams.length > 0 ?
                                    this.state.teams.map(team => <Team key={team.id} {...team} 
                                        editTeam={(e, team) => this.editTeam(e, team)}
                                        leaveTeam={(e, team) => this.leaveTeamConfirm(e, team)}
                                        isCurrent={team.id === this.state.currentTeam} 
                                        //setCurrent={()=> this.props.onTeamListChange(team.id)}
                                        setCurrent={ (e,id)=>this.props.onTeamListChange(id)}
                                    isOwner={(this.state.accNum === team.ownerID)}   />) :
                                    <tr><td>{ tmsg}</td></tr>}

                            </tbody></table></div>
                        </div>
                    </div>
                </div>             
             
                <div>
                    {constContainer}
                </div>
               
            </div>
           
        );
    }
}

class Team extends Component {
 

    render() {
      
        const owneredit = this.props.isOwner ? (
            <button className="btn btn-primary btn-sm" onClick={(e) => this.props.editTeam(e, this.props)} >edit</button>
        ) :
            (<button className="btn btn-primary btn-sm" onClick={(e) => this.props.leaveTeam(e, this.props)} >leave team</button>);

        const current = this.props.isCurrent ? <i className="fa fa-star text-warning"> </i> : "";
        return (<tr><td><div className="title"><button className="btn btn-link " onClick={(e) => this.props.setCurrent(e, this.props.id)}>{this.props.name} </button>  {current}</div></td><td>{owneredit}</td></tr>);
    }
}
